<div class="modal-header">
    <h5 class="modal-title text-white" data-testid="bulk-confirm-modal-title">Confirm bulk send</h5>
</div>
<div class="modal-body" data-testid="bulk-confirm-modal-body">
    <p class="mb-0" data-testid="bulk-confirm-question">
        Are you sure you want to send this template to
        <b data-testid="bulk-confirm-recipient-count">{{ recipientCount }}</b>
        user(s) matching the current dashboard filters?
    </p>
    <p class="mt-2 mb-0 text-muted small" data-testid="bulk-confirm-note">
        Recipients are resolved again at send time — the final count may differ if the data has changed.
    </p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="back()" [disabled]="sending" data-testid="bulk-confirm-back-btn">No, cancel</button>
    <button type="button" class="btn btn-success" (click)="send()" [disabled]="sending" data-testid="bulk-confirm-send-btn">
        <span *ngIf="sending" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Yes, send to all
    </button>
</div>
